import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';

export default function CurrencyFormat({
  value, currency,
}) {
  const { configuracion } = useSelector((state) => state.auth.permisos);
  const currencySymbol = !currency || currency === 'auto' ? configuracion?.moneda : currency;
  if (currencySymbol === '$') {
    return (
      <>
        {currencySymbol}
        {value}
      </>
    );
  }
  return (
    <>
      {value}
      {currencySymbol}
    </>
  );
}

CurrencyFormat.propTypes = {
  currency: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
};
CurrencyFormat.defaultProps = {
  currency: 'auto',
  value: null,
};

export function currencyFormat({
  value, currency, permisos,
}) {
  const { configuracion } = permisos;
  const currencySymbol = !currency || currency === 'auto' ? configuracion?.moneda : currency;

  if (currencySymbol === '$') {
    return currencySymbol + value;
  }
  return value + currencySymbol;
}
